"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _Associations = _interopRequireDefault(require("../../../../../components/Associations"));

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.associations-tab-main-container {\n  flex-grow: 1;\n  padding-top: 0.75rem;\n  padding-left: 0.75rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .associations-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .associations-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .associations-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .associations-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n";
  var fileName = "compone_associations";
  var element = document.querySelector("style[data-sass-component='compone_associations']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Associations = function Associations(_ref) {
  var _applicationRoot$root, _applicationRoot$root2, _rootGroup$id, _validationHook$value;

  var validationHook = _ref.validationHook,
      consumerEntityId = _ref.consumerEntityId,
      _ref$disabledTree = _ref.disabledTree,
      disabledTree = _ref$disabledTree === void 0 ? false : _ref$disabledTree;

  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer, _state$policyReducer$;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer = state.policyReducer) === null || _state$policyReducer === void 0 ? void 0 : (_state$policyReducer$ = _state$policyReducer.associationsReducer) === null || _state$policyReducer$ === void 0 ? void 0 : _state$policyReducer$.applicationRoot;
  }),
      applicationRoot = _useSelector.data;

  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer2, _state$policyReducer3;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer2 = state.policyReducer) === null || _state$policyReducer2 === void 0 ? void 0 : (_state$policyReducer3 = _state$policyReducer2.associationsReducer) === null || _state$policyReducer3 === void 0 ? void 0 : _state$policyReducer3.scopesRoot;
  }),
      globalScopes = _useSelector2.data;

  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
    var _state$policyReducer4, _state$policyReducer5;

    return state === null || state === void 0 ? void 0 : (_state$policyReducer4 = state.policyReducer) === null || _state$policyReducer4 === void 0 ? void 0 : (_state$policyReducer5 = _state$policyReducer4.associationsReducer) === null || _state$policyReducer5 === void 0 ? void 0 : _state$policyReducer5.environmentsRoot;
  }),
      environmentsRoot = _useSelector3.data;

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      environments = _useState2[0],
      setEnvironments = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      environmentData = _useState4[0],
      setEnvironmentData = _useState4[1];

  var rootGroup = applicationRoot === null || applicationRoot === void 0 ? void 0 : (_applicationRoot$root = applicationRoot.rootEnvironmentGroup) === null || _applicationRoot$root === void 0 ? void 0 : (_applicationRoot$root2 = _applicationRoot$root.environmentGroups) === null || _applicationRoot$root2 === void 0 ? void 0 : _applicationRoot$root2.find(function (_ref2) {
    var nativeParentId = _ref2.nativeParentId;
    return !nativeParentId;
  });
  var rootGroupId = (_rootGroup$id = rootGroup === null || rootGroup === void 0 ? void 0 : rootGroup.id) !== null && _rootGroup$id !== void 0 ? _rootGroup$id : null;
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(applicationRoot)) {
      var _applicationRoot$root3;

      var fetchedEnvironments = (0, _utils.getEnvironmentsById)(applicationRoot === null || applicationRoot === void 0 ? void 0 : (_applicationRoot$root3 = applicationRoot.rootEnvironmentGroup) === null || _applicationRoot$root3 === void 0 ? void 0 : _applicationRoot$root3.environments, 'id');
      setEnvironments(fetchedEnvironments);
    }

    if (!(0, _isEmpty.default)(environmentsRoot)) {
      var fetchedEnvironmentData = (0, _utils.getEnvironmentsById)(environmentsRoot, 'environmentId');
      setEnvironmentData(fetchedEnvironmentData);
    }
  }, []);

  var getRootName = function getRootName() {
    // So many different sources of truth for the root name
    // this needs to be improved on the BE somehow
    var rootName = (0, _get2.default)(applicationRoot, 'catalogAppDisplayName') || (0, _get2.default)(applicationRoot, 'catalogAppName');

    if ((0, _get2.default)(applicationRoot, 'catalogApplication.requiresHierarchicalModel')) {
      var _get;

      rootName = ((_get = (0, _get2.default)(applicationRoot === null || applicationRoot === void 0 ? void 0 : applicationRoot.allEnvironmentGroupMap, [rootGroupId], {})) === null || _get === void 0 ? void 0 : _get.name) || rootName;
    }

    return rootName;
  };

  var allowedScopesData = {
    environmentGroups: !(0, _isEmpty.default)(globalScopes) && (globalScopes === null || globalScopes === void 0 ? void 0 : globalScopes.map(function (obj) {
      return obj === null || obj === void 0 ? void 0 : obj.value;
    })) || [],
    environments: []
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.mainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "associations-tree-container",
    className: "associations-tree-container"
  }, !(0, _isEmpty.default)(applicationRoot) && !(0, _isEmpty.default)(environments) && !(0, _isEmpty.default)(environmentData) ? /*#__PURE__*/_react.default.createElement(_Associations.default, {
    key: "associations-".concat(consumerEntityId),
    disabled: disabledTree,
    environmentGroups: applicationRoot === null || applicationRoot === void 0 ? void 0 : applicationRoot.allEnvironmentGroupMap,
    environments: environments,
    environmentData: environmentData,
    defaultDirectory: applicationRoot === null || applicationRoot === void 0 ? void 0 : applicationRoot.appContainerId,
    applicationRoot: {
      id: rootGroupId,
      name: getRootName(),
      appIcon: applicationRoot === null || applicationRoot === void 0 ? void 0 : applicationRoot.iconUrl
    },
    checkedNodes: (validationHook === null || validationHook === void 0 ? void 0 : (_validationHook$value = validationHook.values) === null || _validationHook$value === void 0 ? void 0 : _validationHook$value.scopes) || [],
    onChange: function onChange(updatedCheckedNodes) {
      return validationHook.handleChange(validationHook.names.scopes, updatedCheckedNodes);
    },
    allowedScopes: allowedScopesData || {},
    appName: (0, _get2.default)(applicationRoot, 'catalogAppName')
  }) : null)));
};

Associations.propTypes = {
  validationHook: _propTypes.default.object,
  consumerEntityId: _propTypes.default.string,
  disabledTree: _propTypes.default.bool
};
var _default = Associations;
exports.default = _default;